import React from 'react';

import Loading from 'shared/components/Loading';

const LoaderPage = () => {
  return <Loading />;
};

export default LoaderPage;
